<div provideParentForm>
    <avi-radio-container *ngIf="!isGSLBServiceRecordTypeSRV">
        <avi-radio
            name="ip-address"
            id="ip-address"
            [(ngModel)]="isConfiguredByTypeIp"
            (ngModelChange)="handleMemberConfigurationTypeChange()"
            [value]="true"
        >
            {{ globalL10nKeys.ipAddressLabel | vtranslate }}
        </avi-radio>
        <avi-radio
            name="virtual-service"
            id="virtual-service"
            [(ngModel)]="isConfiguredByTypeIp"
            (ngModelChange)="handleMemberConfigurationTypeChange()"
            [value]="false"
        >
            {{ globalL10nKeys.virtualServiceLabel | vtranslate }}
        </avi-radio>
    </avi-radio-container>

    <gslb-pool-member-domain-name
        *ngIf="isConfiguredByTypeIp"
        [editable]="editable"
        [isGSLBServiceRecordTypeSRV]="isGSLBServiceRecordTypeSRV"
        (onIpOrFqdnChange)="handleAddressChange()"
    ></gslb-pool-member-domain-name>

    <gslb-pool-member-virtual-service
        *ngIf="!isConfiguredByTypeIp"
        [editable]="editable"
        [siteClusterControllerDropdownOptions]="siteClusterControllerDropdownOptions"
        [selectedSiteVsCollection]="selectedSiteVsCollection"
        [resolvedVsVipIpDropdownOptions]="resolvedVsVipIpDropdownOptions"
        (onSiteClusterControllerChange)="handleSiteClusterControllerChange()"
        (onVsSelectionChange)="handleVsSelectionChange()"
        (onResolvedVsVipIpChange)="handleAddressChange()"
    ></gslb-pool-member-virtual-service>
</div>
